const Ls14AsearBebe = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-12 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>C&oacute;mo asear a mi <span className="titulo--lesson--color--2">beb&eacute; prematuro</span></h1>

                    <h1 className="text--subtitulo p-4">No es aconsejable ba&ntilde;ar a los beb&eacute;s prematuros porque su piel es muy fina y delicada, y para mantener su temperatura</h1>

                    <div className='container py-3'>
                        <div className='row d-flex align-items-center'>
                            <div className='col-3 col-ms-4 col-md-4 col-lg-4 col-xl-2'>
                                <img src="./img/Ls14-Icon.png" className='' />
                            </div>
                            <div className='col-9 col-ms-8 col-md-8 col-lg-8 col-xl-10'>
                                <p className='texto--parrafo ps-lg-4 ps-xl-4'>Bastar&aacute; con limpiarle con un pa&ntilde;ito suave y h&uacute;medo la zona del pa&ntilde;al, la cara, las manos y los pliegues donde puedan encontrarse restos de leche o suciedad. <br /><br />Realice esta tarea en la habitaci&oacute;n m&aacute;s c&aacute;lida de la casa y, si fuera necesario, utilice un calefactor para entibiarla.</p>
                            </div>
                        </div>
                    </div>

                    <div className='container'>
                        <div className='row d-flex ps-4 pt-4'>
                            <div className='col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex style--burbuja py-2 align-items-center'>
                                <div className='col-3 col-ms-3 col-md-2 col-lg-1 col-xl-1'>
                                    <img src="./img/Ls2IconEstetoscopio.png" className='' />
                                </div>
                                <div className='col-9 col-ms-9 col-md-9 col-lg-9 col-xl-11'>
                                <p className='texto--burbuja lh-1 ps-lg-3 ps-xl-5 m-1'>El ba&ntilde;o del beb&eacute; solo ser&aacute; autorizado por el/la pediatra cuando el peso y las condiciones del beb&eacute; sean los adecuados.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='container ps-4 pt-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='http://www.nhs.uk/conditions/pregnancy-and-baby/pages/washing-your-baby.aspx#close'>http://www.nhs.uk/conditions/pregnancy-and-baby/pages/washing-your-baby.aspx#close</a></p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Ls14AsearBebe;